console.log('you can do something here like insert custom Semi theme')